const DIGIT = '9';
const ALPHA = 'A';
const ALPHANUM = 'S';
const controlChars = [DIGIT, ALPHA, ALPHANUM];
const numberRegExp = /[0-9]/;
const alphaRegExp = /[a-zA-Z]/;
const alphaNumRegExp = /[a-zA-Z0-9]/;
/**
 * Simliar to VMasker.toPattern, but keeps the cursor position consistent.  Editing the middle of the input will no longer
 * cause the cursor to jump to the end.
 */
export const inputPattern = (inputOrEl, pattern) => {
    const inputIsString = typeof inputOrEl === 'string';
    const input = inputIsString ? inputOrEl : inputOrEl.value;
    const el = inputIsString ? undefined : inputOrEl;
    const patternChars = pattern.split('');
    const inputChars = input.split('');
    // index of the current input character
    let inputIndex = 0;
    let selectionStart = (el === null || el === void 0 ? void 0 : el.selectionStart) || 0;
    let selectionEnd = (el === null || el === void 0 ? void 0 : el.selectionEnd) || 0;
    const normalized = [];
    // normalize the input by removing all non-control characters
    for (const patternChar of patternChars) {
        if (controlChars.includes(patternChar)) {
            while (inputIndex < inputChars.length) {
                if ((patternChar === DIGIT && numberRegExp.test(inputChars[inputIndex])) ||
                    (patternChar === ALPHA && alphaRegExp.test(inputChars[inputIndex])) ||
                    (patternChar === ALPHANUM && alphaNumRegExp.test(inputChars[inputIndex]))) {
                    normalized.push(inputChars[inputIndex]);
                    ++inputIndex;
                    break;
                }
                else {
                    if (normalized.length < selectionStart) {
                        selectionStart--;
                    }
                    if (normalized.length < selectionEnd) {
                        selectionEnd--;
                    }
                }
                ++inputIndex;
            }
        }
    }
    const normalizedLength = normalized.length;
    inputIndex = 0;
    const output = [];
    // add the control characters back in
    for (const patternChar of patternChars) {
        if (inputIndex >= normalizedLength) {
            break;
        }
        if (controlChars.includes(patternChar)) {
            output.push(normalized[inputIndex]);
            ++inputIndex;
        }
        else {
            output.push(patternChar);
            if (output.length <= selectionStart) {
                ++selectionStart;
            }
            if (output.length <= selectionEnd) {
                ++selectionEnd;
            }
        }
    }
    const value = output.join('');
    if (el) {
        el.value = value;
        // number inputs do not support selection
        if (el.type !== 'number') {
            el.setSelectionRange(selectionStart, selectionEnd);
        }
    }
    return value;
};
//# sourceMappingURL=input-pattern.js.map